<template>
  <modal class="modal p-3" name="direct-link-modal" transition="pop-out" :width="modalWidth" height="auto" :adaptive="true">
    <div class="flex flex-column items-center mb3 modal-padding">
      <h2>Crear Acceso directo</h2>
      <p>
        Para agregar un acceso directo de este sitio web a tu pantalla de inicio debes acceder al menú
        pulsando el ícono de los tres puntos situado en la parte superior derecha del navegador. Luego
        selecciona la opción "añadir a pantalla de inicio" ó en inglés ("Add to Home Screen")
      </p>
    </div>
  </modal>
</template>

<script>
  const MODAL_WIDTH = 500

  export default {
    name: 'direct-link-modal',
    methods: {
      closeModal () {
        this.$modal.hide('direct-link')
      }
    },
    data () {
      return {
        modalWidth: MODAL_WIDTH,
        forgotModal: false,
        color: '#808080',
        size: '20px'
      }
    },
    created () {
      this.modalWidth = window.innerWidth < MODAL_WIDTH
        ? MODAL_WIDTH / 2
        : MODAL_WIDTH
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@/variables.scss';
  
  .modal {
    z-index: 10000;
  }
  .pop-out-enter-active,
  .pop-out-leave-active {
    transition: all 0.5s;
  }
  .pop-out-enter,
  .pop-out-leave-active {
    opacity: 0;
    transform: translateY(24px);
  }
  .modal-padding{
    padding: 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/provider/DirectLinkModal.vue